/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { vappContainer } from '@/application';
import { LandingPage as LandingPageWidget } from '@widgets/landing-page-widget';

import { useSMCreateDeathEventPage, useSMCreateDeathEvent } from '../machines';
import { useTheme } from '@providers/theme';
import { VApplication } from '@/application';
import { CreateDeathEventPageService } from '../services';
import { TweetyWidget } from '@vlinder-web/tweety-widget-react';
import { createDeathEventConfig } from '../config/createDeathEvent';
import { Container } from 'react-bootstrap';
import LandingPage from '@/pages/LandingPage';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import {
  Footer,
  HeaderComp,
  Sidebar,
} from '../widgets/landing-page-widget/components';
import footerData from '../services/config/footer.config.json';
import headerData from '../services/config/header.config.json';
import { useNavigate } from 'react-router-dom';

const getSrv = () => {
  return vappContainer.get<CreateDeathEventPageService>(
    CreateDeathEventPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const { bp, width } = useViewport();
  const theme = useTheme();
  const navigate = useNavigate();
  const [buttonItem, setButtonItem] = useState();
  const srv = getSrv();

  useEffect(() => {
    async function getNavItems() {
      let _navlinks = await srv?.getHeaderNavItems();
      if (_navlinks) {
        setButtonItem(_navlinks);
      }
    }
    setTimeout(() => {
      getNavItems();
    }, 500);
  }, []);

  const {
    createDeathEventPageMachine,
    createDeathEventPageState,
    createDeathEventPageSend,
  } = useSMCreateDeathEventPage({});

  
  const { createDeathEventMachine, createDeathEventSend, createDeathEventState } =
  useSMCreateDeathEvent({});


  useEffect(()=> {
    if(createDeathEventState?.matches('UPDATE_KYC_SUCCESS')){
      navigate("/")
    }
  },[createDeathEventState])

  const _getHeader = () => {
    if (bp === 'xs' || width <= 990) {
      return <Sidebar {...headerData} />;
    } else {
      return <HeaderComp {...headerData} />;
    }
  };

  const _renderPage = () => {
    if (createDeathEventPageState?.matches('RENDER_PAGE')) {
      return (
        <>
          {_getHeader()}
          <Container className="mb-5">
            <TweetyWidget
              labelColor={theme.colors.primary}
              fields={FIELDS}
              layout={layout}
              onFormSubmit={(data) =>
                createDeathEventSend('START', {
                  payload: {
                    ...data,
                  },
                })
              }
            />
          </Container>
          <Footer {...footerData} />
        </>
      );
    }
    if (createDeathEventPageState?.matches('GET_PAGE_CONTENT')) {
      return <div>Loading...</div>;
    }
    return null;
  };
  return <>{_renderPage()}</>;
};

const FIELDS: any = [
  {
    type: 'datepicker',
    compProps: {
      id: 'dod',
      label: 'Select Date of Death',
      required: true,
      errorText: 'Date of death is required',
    },
  },
  {
    type: 'text',
    compProps: {
      id: 'aadharNo',
      label: 'Aadhar Number',
      required: true,
      placeholder: 'Enter Aadhar Number',
      errorText: 'Aadhar Number is required',
    },
  },
  {
    type: 'text',
    compProps: {
      id: 'cause',
      label: 'Cause of Death',
      required: true,
      placeholder: 'Enter Cause of Death',
      errorText: 'Cause of Death is required',
    },
  },
  {
    type: 'select',
    compProps: {
      id: 'deathCertificate',
      label: 'Death Certificate',
      required: true,
      options: [
        {
          id: 'issued',
          label: 'ISSUED',
        },
        {
          id: 'notIssued',
          label: 'NOT ISSUED',
        },
      ],
      errorText: 'Select any one option',
    },
  },
];

const layout = [
  ['dod', 'aadharNo'],
  ['cause', 'deathCertificate'],
];
